module.exports = __webpack_public_path__ + "static/media/logo.6d0c5595.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 91
// module chunks = 0